// removed by extract-text-webpack-plugin
module.exports = {"header":"_29joqUwxqvsaXtet4e4b69","header--dark":"_2uoDc6ZU-3Jf9piZYimRDV","headerDark":"_2uoDc6ZU-3Jf9piZYimRDV","active":"KptAVzuuhJBXji4XR11QG"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/Header/style.scss
// module id = 606
// module chunks = 0